import { Receipt, Truck, Zap } from 'lucide-react';
import i18n from '@/settings/i18n';

const t = i18n.init('buyback');

const CONTENT = [
  {
    title: 'Get a quote',
    description:
      'Answer a few quick questions and get a guaranteed quote in under a minute.',
    icon: <Zap className="h-5 w-5" />,
  },
  {
    title: 'Ship for free',
    description:
      'Pack your device and send it to our partner with the prepaid label sent to your email.',
    icon: <Truck className="h-5 w-5" />,
  },
  {
    title: 'Get paid',
    description:
      'Once your device is inspected and offer is confirmed, get paid via bank transfer or PayPal.',
    icon: <Receipt className="h-5 w-5" />,
  },
];

const TradeInSteps = () => (
  <div className="bg-white py-6 xxs:py-8 md:py-10">
    <div className="reebelo-container">
      <h2 className="mb-4 text-center font-bold">
        {t`3 Easy Steps to Trade-In Your Tech`}
      </h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {CONTENT.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center rounded-md border p-4 text-center lg:p-10"
          >
            <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-md bg-[#ECFCF5] lg:h-12 lg:w-12">
              {item.icon}
            </div>
            <h3 className="mb-2 text-sm font-medium lg:text-base">
              {t(item.title)}
            </h3>
            <p className="text-sm text-gray-700/75">{t(item.description)}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default TradeInSteps;
